import * as React from "react"
import { ReactNode } from "react"

export interface CascaderTabBaseProps {
  className?: string
  children?: ReactNode
}

function CascaderTab(props: CascaderTabBaseProps) {
  return <></>
}

export default CascaderTab
